"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRaceRatingById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates/updates a race rating.
 *
 * ### Updatable fields
 * - `rating`
 * - `difficulty`
 *
 * ## Usage
 * ```ts
 * const raceId: string = "5f5e555d5a578b6";
 * const raceRating: Partial<RaceRating> = {
 * 		discordId: "123",
 * 		raceId: "5f5e555d5a578b6",
 * 		fun: 1,
 * 		difficulty: 3
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateRaceRatingById({ raceId, raceRating });
 * ```
 *
 * @param params.raceId     - ID of the race to update.
 * @param params.raceRating - Fields to update in the chosen race.
 */
const updateRaceRatingById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, raceRating } = params;
    const url = `${BASE_URL}/races/race/${raceId}/rate`;
    const response = yield axios_1.default.put(url, raceRating, { validateStatus: () => true });
    const { status, data } = response;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateRaceRatingById = updateRaceRatingById;
